import { Actions } from 'components/Actions';
import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

export const useColumns = () =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Catalogs',
        columns: [
          {
            Header: 'Catalog',
            accessor: 'catalog',
          },
          {
            accessor: 'action',
            Cell: () => <Actions isManagePath toTheRight />,
          },
        ],
      },
    ],
    []
  );
